import { Component } from '@angular/core';
import { IonicPage, ToastController, NavController, NavParams, ViewController, AlertController, App } from 'ionic-angular';
//import { AdministerPage } from '../administer/administer';
import { Client } from '../../models/client';
import { Items } from '../../providers/providers';
import { UserAccount } from '../../models/account';
import { Grouping } from '../../models/groupings';
//import { AdministerPage } from '../administer/administer';
/**
 * Generated class for the ClientGroupingPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 * the tags module is from https://github.com/HsuanXyz/ionic-tags-input
 */


@IonicPage()
@Component({
  selector: 'page-client-grouping',
  templateUrl: 'client-grouping.html',
})
export class ClientGroupingPage {

  clientId: string;
  clientName: string;
  groupName: string;
  group: Grouping;
  clients: Client[];
  latest: Client[];
  clientsTag: Client[] = [];
  clientNameTag = [];
  client: Client;
  selected = [];
  isReadyToSend: boolean;
  userAccountData: UserAccount;

  selectedClients: { first_name: string, last_name: string } = {
    first_name: 'First Name',
    last_name: 'Last Name'
  };

  constructor(public navCtrl: NavController, public toastCtrl: ToastController, public navParams: NavParams, public viewCtrl: ViewController, public items: Items, public alertCtrl: AlertController, public appCtrl: App) {
    
  }

  ionViewDidLoad() {
    this.items.getClientList().subscribe(res => {
      if (res) {
        this.clients = res;

        this.latest = this.navParams.data.clients;
        this.group = this.navParams.data.group;
        this.groupName = this.group.name;
      }
    }, err => {
      console.error('ERROR', err);
    });
  }

  getClientForId(clientId) {
    return this.clients.find(x => x.id == clientId);
  }

  cancel() {
    this.viewCtrl.dismiss(this.latest);
  }

  clientSelected(item) {
    this.isReadyToSend = true;
    var index = this.clientsTag.indexOf(item);
    if (index > -1) {
      this.clientsTag.splice(index, 1);
      this.clientNameTag.splice(index, 1);
      item.selected = false;
      if (this.clientsTag.length == 0) {
        this.isReadyToSend = false;
      }
    } else {
      //little hack to display the tag name
      // item.selected = true;
      this.clientsTag.push(item);
      this.clientNameTag.push(item.first_name + ' ' + item.last_name);
      item.selected = true;
    }

  }

  onChange(val) {
    // 10/06/2019 val always return the array after deleting the element. 
    //1. assign the clientsTag to a temp array and then find the index of deleted element. delete all other elements except the removed element
    //2. set the selected property to false and find it's index in the temp array.
    //3. delete the index from temp array and assign it back to clientsTag array
    // Can be done in one line like below but how to set the selected property to false ?
    // var filteredArray = this.clientsTag.filter(e=> val.includes(e.short_name));
    // console.log(filteredArray);
    var tempArray = new Array<Client>();
    tempArray = this.clientsTag.slice();
    for (let i = 0; i < val.length; i++) {
      var name = val[i];
      var index = this.clientsTag.findIndex(x => x.first_name == name);
      if (index > -1) {
        this.clientsTag.splice(index, 1);
      }
    }
    this.clientsTag[0].selected = false;
    var index = tempArray.findIndex(i => i.first_name === this.clientsTag[0].first_name);
    tempArray.splice(index, 1);
    this.clientsTag = tempArray;
    if (this.clientsTag.length == 0) {
      this.isReadyToSend = false;
    }
    // var index = this.assessmentsTag.indexOf(val);
    // if (index > -1) {
    //   this.assessmentsTag.splice(index,1);
    //   this.assessmentNameTag.splice(index,1);
    //   if(this.assessmentsTag.length == 0){
    //     this.isReadyToSend = false;
    //   }
    // }
    // }
  }

  filterClients(ev) {
    var val = ev.target.value;
    this.clients = this.items.getClients(val);
    return this.clients;

  }

  addClients() {
    this.items.addClientGrouping(this.clientsTag, this.group.id).subscribe((resp) => {
      if (resp) {
        this.presentToast("Clients successfully added to group");
        this.latest = resp.grouping.Client;
        this.viewCtrl.dismiss(this.latest);
      }
    }, (err) => {

    })
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 7000,
      position: 'top'
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/client-grouping/client-grouping.ts